import React, { useEffect } from "react";
import Swal from "sweetalert2";
import axios from "axios";

const AddDeptModal = ({ isAddOpen, onAddClose, formData, setFormData, fetchData, user, branch }) => {
  // ✅ Hook at top level (always runs)
  useEffect(() => {
    const fetchDeptNo = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/dept_addNo");
        if (response.data.newDeptNo) {
          setFormData({
            dptNo: response.data.newDeptNo,
            deptName: "",
            user,
            branch,
          });
        }
      } catch (error) {
        console.error("Error fetching Department Number:", error);
      }
    };

    if (isAddOpen) {
      fetchDeptNo();
    }
  }, [isAddOpen, setFormData, user, branch]);

  // ✅ Now conditionally return JSX
  if (!isAddOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (!formData.deptName || formData.deptName.trim() === "") {
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Department Name should not be empty.",
      });
      return;
    }

    try {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await axios.post("https://rfs2.infraconsoft.net.in/api/dept_insert", {
        deptCode: formData.dptNo,
        deptName: formData.deptName,
        user,
        branch,
      });

      if (response.data.success) {
        Swal.fire({
          icon: "success",
          title: "Inserted!",
          text: "Department inserted successfully.",
        });

        // ✅ Get new code for next insert
        const newCode = await axios.get("https://rfs2.infraconsoft.net.in/api/dept_addNo");
        setFormData({
          dptNo: newCode.data.newDeptNo,
          deptName: "",
          user,
          branch,
        });

        onAddClose();
        fetchData();
      }
    } catch (error) {
      console.error("Error inserting department:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Insert failed. Please try again.",
      });
    }
  };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
        <div style={{ position: "absolute", top: "10px", right: "10px" }}>
          <button className="close-btn" onClick={onAddClose} style={{ position: "initial" }}>
            &times;
          </button>
        </div>
        <h3>Add New Department</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label>Department Code :</label>
              <input type="text" name="dptNo" value={formData.dptNo || ""} readOnly />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Department Name :</label>
              <input
                type="text"
                name="deptName"
                value={formData.deptName || ""}
                onChange={handleEditChange}
              />
            </div>
          </div>

          <div className="btn-cls">
            <button type="submit" className="submit-btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDeptModal;
